import * as S from "./style";

export default function Button({nome = "assinar sem mensalidade", url, textSize}) {
    return (
        <S.Container>
            <a href={url}><S.Button textSize={textSize}>{nome}</S.Button></a>
        </S.Container >
    )
}